module.exports = __webpack_public_path__ + "img/ic-edit-title.38d857d0.svg";